module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/BSuhDF/tc-custom/9781504094283.jpg?1726444214844",
      "alt": "This image is the cover for the book Mystery of the Blue Train, The Hercule Poirot Mysteries"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Mystery of the Blue Train, The Hercule Poirot Mysteries\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("In this classic mystery by the Queen of Crime, Hercule Poirot boards a night train bound for the French Riviera . . . and murder.")])]), _c('p', [_vm._v(" American heiress Ruth Kettering needs to get away from it all. She’s left her unhappy marriage behind her and booked a ticket on the luxurious Blue Train, heading to the French Riviera where her lover is waiting. But when the train arrives in Nice, Ruth is found dead in her cabin, and her priceless ruby is missing. ")]), _c('p', [_vm._v(" Although the evidence points to Ruth’s estranged husband as the prime suspect, Hercule Poirot is not so sure. Now, to make sense of this perplexing puzzle, there’s only one thing the great Belgian detective can do: recreate the murder. ")]), _c('i', [_vm._v("Originally published in 1928")]), _vm._v(".\n    "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Agatha Christie\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Agatha Christie (1890–1976) is listed in the Guinness Book of World Records as the bestselling novelist of all time. The first recipient of the Mystery Writers of America’s Grand Master Award, she published eighty mystery novels and many short story collections and created such iconic fictional detectives as Hercule Poirot, Miss Jane Marple, and Tommy and Tuppence Beresford. She is known around the world as the Queen of Crime.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    MysteriousPress.com/Open Road Integrated Media, Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0